import React, { useState } from "react";
import { cn } from "@/lib/utils";
import { Skeleton } from "./skeleton";

interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string | undefined;
  alt: string | undefined;
  className?: string;
}

const LazyImage: React.FC<LazyImageProps> = ({
  src,
  alt,
  className,
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="relative">
      {isLoading && (
        <Skeleton
          className={cn("absolute top-0 left-0 right-0 bottom-0", className)}
        />
      )}
      <img
        src={src}
        alt={alt}
        className={cn(
          isLoading ? "opacity-0" : "opacity-100",
          "transition-opacity duration-300",
          className,
        )}
        loading="lazy"
        onLoad={() => setIsLoading(false)}
        {...props}
      />
    </div>
  );
};

export default LazyImage;
